const isSegmentationRuleMatching = (target_value, target_condition, relevantAttribute) => {
  return !!target_value.find((value) => {
    if (target_condition === "equals") {
      return value === relevantAttribute;
    } else if (target_condition === "contains") {
      return `${relevantAttribute}`.includes(value);
    }
  });
};
const findMatchingRuleByAttributes = (targetRules, attributes) => {
  let matchingReference;
  for (let i = 0; i < (targetRules == null ? void 0 : targetRules.length); i++) {
    const targetRule = targetRules[i];
    const isInclusion = !!(targetRule == null ? void 0 : targetRule.inclusion_rule);
    const rule = isInclusion ? targetRule == null ? void 0 : targetRule.inclusion_rule : targetRule == null ? void 0 : targetRule.exclusion_rule;
    const {
      ajo_segment,
      segment_type,
      segment_condition = {},
      segmented_content_reference = []
    } = rule || {};
    const { target_condition = "equals", target_value = [] } = segment_condition;
    let relevantAttribute;
    if (ajo_segment) {
      relevantAttribute = attributes["segmentNumber"];
    } else if (segment_type === "warehouse_id") {
      relevantAttribute = attributes["warehouseId"];
    } else if (segment_type === "membership_type") {
      relevantAttribute = attributes["membershipType"];
    }
    if (!relevantAttribute) {
      return;
    }
    const isRuleMatch = isSegmentationRuleMatching(
      ajo_segment ? [ajo_segment == null ? void 0 : ajo_segment.id] : target_value,
      target_condition,
      relevantAttribute
    );
    if (isInclusion && isRuleMatch) {
      matchingReference = segmented_content_reference[0];
      break;
    } else if (!isInclusion && !isRuleMatch) {
      matchingReference = segmented_content_reference[0];
      break;
    }
  }
  return matchingReference;
};
export {
  findMatchingRuleByAttributes,
  isSegmentationRuleMatching
};
